import { jsx } from 'react/jsx-runtime';
import { cn } from '../../lib/utils.js';

const ConfirmBox = ({ children, className }) => {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn(
        "flex items-center justify-center gap-2 h-[120px] bg-primary-background-08 border border-primary-04 rounded-[12px]",
        className
      ),
      children: /* @__PURE__ */ jsx("strong", { className: "eng-heading-h1 font-weight-bold text-primary-05 !tracking-[0.5rem] pt-1", children })
    }
  );
};

export { ConfirmBox };
